(() => {
  if (window.__ngGoogleAttribution || window.Shopify?.designMode) return;
  window.__ngGoogleAttribution = true;
  const key = 'ng_google_attribution_v1';
  const ttl = 30 * 24 * 60 * 60 * 1000;
  const fields = ['gclid', 'wbraid', 'gbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_content', 'utm_term', 'utm_source_platform', 'ng_adgroup', 'ng_ad', 'ng_device', 'ng_network', 'ng_matchtype'];
  const names = Object.fromEntries(fields.map(f => [f, f === 'gclid' ? 'ng_google_click_id' : 'ng_google_' + f]));
  names.captured_at = 'ng_google_captured_at';
  names.landing_path = 'ng_google_landing_path';
  names.line = 'ng_google_line';
  const lines = {'208291446224':'cofres', '202431088318':'cuenta_tu_historia', '201568187517':'lentes'};
  const params = new URLSearchParams(window.location.search);
  const arrival = Object.fromEntries(fields.map(f => [f, (params.get(f) || '').trim().slice(0, 300)]));
  const isGoogle = Boolean(arrival.gclid || arrival.wbraid || arrival.gbraid) || (arrival.utm_source.toLowerCase() === 'google' && arrival.utm_medium.toLowerCase() === 'cpc');
  const candidate = isGoogle && arrival.utm_campaign !== 'ng_attribution_qa' ? {...arrival, captured_at:new Date().toISOString(), landing_path:window.location.pathname, line:lines[arrival.ng_adgroup || arrival.utm_content.split('_')[0]] || ''} : null;
  let active;
  let revision = 0;
  let chain = Promise.resolve();
  const root = window.Shopify?.routes?.root || '/';
  let initialCart;
  try { initialCart = {attributes:JSON.parse(document.getElementById('ng-google-cart-state')?.textContent || 'null')}; } catch {}
  const allowed = () => {
    const p = window.Shopify?.customerPrivacy;
    return Boolean(p && p.analyticsProcessingAllowed() && p.marketingAllowed());
  };
  const read = () => {
    try {
      const data = JSON.parse(localStorage.getItem(key) || 'null');
      const age = Date.now() - Date.parse(data?.captured_at);
      return data && data.utm_campaign !== 'ng_attribution_qa' && age >= 0 && age < ttl ? data : null;
    } catch { return null; }
  };
  const store = data => {
    try { if (data) localStorage.setItem(key, JSON.stringify(data)); else localStorage.removeItem(key); } catch {}
  };
  const attributes = data => Object.fromEntries(Object.entries(names).map(([field, name]) => [name, data?.[field] || '']));
  const sync = (data, currentRevision) => {
    chain = chain.catch(() => {}).then(async () => {
      if (currentRevision !== revision || (data && !allowed())) return;
      let cart = initialCart?.attributes ? initialCart : null;
      initialCart = null;
      if (!cart) {
        const response = await fetch(root + 'cart.js', {credentials:'same-origin', cache:'no-store'});
        if (!response.ok) return;
        cart = await response.json();
      }
      if (currentRevision !== revision || (data && !allowed())) return;
      const wanted = attributes(data);
      const changed = Object.fromEntries(Object.entries(wanted).filter(([name, value]) => String(cart.attributes?.[name] || '') !== value));
      if (!Object.keys(changed).length) return;
      await fetch(root + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes:changed})});
    }).catch(() => {});
  };
  const refresh = () => {
    revision += 1;
    if (!allowed()) {
      active = null;
      store(null);
      sync(null, revision);
      return;
    }
    active = candidate || read();
    store(active);
    sync(active, revision);
  };
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refresh(); });
  const init = () => {
    if (window.Shopify?.customerPrivacy) refresh();
    else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], error => { if (!error) refresh(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
